import React from "react";
import { func } from "prop-types";
import { Grid, Button, Icon } from "semantic-ui-react";
import { ButtonRow } from "./Components";
import { translate } from "react-i18next";

class EditingHeader extends React.PureComponent {
  static propTypes = {
    onSave: func.isRequired,
    onCancel: func.isRequired
  };

  render() {
    let { onSave, onCancel, t } = this.props;
    return (
      <Grid style={{marginTop: 15}}>
        <ButtonRow>
          <Button icon onClick={onSave}>
            <Icon name="check" color="green" />
            {t("save")}
          </Button>
          <Button onClick={onCancel} icon>
            <Icon name="remove circle" color="red" />
            {t("cancel")}
          </Button>
        </ButtonRow>
        <Grid.Row>
          <Grid.Column>{this.props.children}</Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default translate()(EditingHeader);
export { EditingHeader };
